import { createContext, useContext } from 'react';

import type { JwtPayload } from '../types/api';

export interface AuthContextValue {
    isAuthenticated: boolean;
    isAdmin: boolean;
    payload: JwtPayload | null;
    loginWithOtp: (params: { email?: string; phone?: string; otp: string }) => Promise<void>;
    logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return ctx;
}
